import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'identify',
            props: {
                uuid: '@profile.data.uuid',
            },
            traits: {
                ...segmentProps,
            },
        },
    },
};
